import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", company: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      await register(f.email.trim().toLowerCase(), f.password, f.name.trim(), f.company.trim());
      toast.success("Account created");
      nav("/portal");
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      let msg = "Could not create account";
      if (typeof d === "string") msg = d;
      else if (Array.isArray(d) && d[0]?.msg) {
        const field = d[0].loc?.slice(-1)[0];
        msg = field ? `${field}: ${d[0].msg}` : d[0].msg;
      } else if (e2?.message && !e2?.response) msg = `Network error: ${e2.message}`;
      else if (e2?.response?.status) msg = `${msg} (status ${e2.response.status})`;
      console.error("Register failed:", e2);
      setErr(msg);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-[1fr_480px]" data-testid="register-root">
      <div className="p-12 hidden md:flex flex-col justify-between" style={{ background: "var(--ink)", color: "var(--cream-2)" }}>
        <Link to="/" className="text-2xl font-display font-black">Ask<span style={{ color: "var(--kiwi-2)" }}>Tax</span></Link>
        <div>
          <span className="eyebrow light">Create your account</span>
          <h1 className="h1-display mt-4" style={{ fontSize: 56 }}>
            Ask your first<br /><span className="font-serif-i font-normal" style={{ textTransform: "none", color: "var(--kiwi-2)" }}>tax question.</span>
          </h1>
          <p className="mt-6 font-serif text-lg" style={{ color: "var(--cream-3)" }}>
            Once you're in, submit a question, pay $67 (or grab the 3-pack for $127) and a registered NZ tax agent takes it from there.
          </p>
        </div>
        <div className="text-xs" style={{ color: "var(--muted-2)" }}>Secure payment · GST included on every invoice</div>
      </div>
      <div className="p-8 md:p-12 flex items-center justify-center" style={{ background: "var(--cream)" }}>
        <form onSubmit={submit} className="at-card p-8 w-full max-w-md">
          <div className="text-2xl font-display font-black uppercase">Create account</div>
          {err && <div className="mt-4 p-3 border-2 text-sm font-display font-bold uppercase tracking-wide" style={{ borderColor: "var(--clay)", background: "#f4e0d8", color: "var(--clay)" }} data-testid="register-error">{err}</div>}
          <div className="mt-6">
            <label className="at-label">Your name</label>
            <input required className="at-input" value={f.name} onChange={e => setF({ ...f, name: e.target.value })} data-testid="register-name" />
          </div>
          <div className="mt-4">
            <label className="at-label">Company (optional)</label>
            <input className="at-input" value={f.company} onChange={e => setF({ ...f, company: e.target.value })} data-testid="register-company" />
          </div>
          <div className="mt-4">
            <label className="at-label">Email</label>
            <input required type="email" className="at-input" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} data-testid="register-email" />
          </div>
          <div className="mt-4">
            <label className="at-label">Password</label>
            <input required type="password" className="at-input" minLength={6} value={f.password} onChange={e => setF({ ...f, password: e.target.value })} data-testid="register-password" />
          </div>
          <button disabled={busy} className="at-btn block mt-6" data-testid="register-submit">{busy ? "Creating…" : "Create account"}</button>
          <div className="mt-4 text-xs" style={{ color: "var(--muted)" }} data-testid="register-legal-note">
            By creating an account you agree to our <Link to="/legal" className="font-bold" style={{ color: "var(--kiwi)" }} data-testid="register-terms-link">Terms of Service</Link> and <Link to="/privacy" className="font-bold" style={{ color: "var(--kiwi)" }} data-testid="register-privacy-link">Privacy Policy</Link>.
          </div>
          <div className="mt-4 text-sm">
            Already have one? <Link to="/login" className="font-bold" style={{ color: "var(--kiwi)" }} data-testid="register-to-login">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
